"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageWorldState = exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageStarmapGenerator_sidecar_1 = require("@voyage/starmap/voyageStarmapGenerator-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.StarmapCreate;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.seed);
    messageWriter_sidecar_1.messageWriter.write32(m, d.ci);
    messageWriter_sidecar_1.messageWriter.write32(m, d.cj);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        seed: messageWriter_sidecar_1.messageWriter.read32(m),
        ci: messageWriter_sidecar_1.messageWriter.read32(m),
        cj: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        seed: 101,
        ci: 23,
        cj: 10023,
    };
    messageWriter_sidecar_1.messageWriter.test('starmap-create', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    voyageStarmapGenerator_sidecar_1.voyageStarmapGenerator.generateStarmap(msg.seed);
    voyageStarmapGenerator_sidecar_1.voyageStarmapGenerator.travelTo(msg.ci, msg.cj, true);
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
function sendMessageWorldState(msg, multiId) {
    websockets_sidecar_1.websockets._sendMessageWorldState(write, msg, multiId);
}
exports.sendMessageWorldState = sendMessageWorldState;
